import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisualStudio = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "2.53101 2.53113 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_117157_1874",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 2,
			y: 2,
			width: 55,
			height: 55,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M2.53101 2.53113H56.5311V56.5312H2.53101V2.53113Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_117157_1874)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask1_117157_1874",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 2,
				y: 2,
				width: 55,
				height: 55,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M2.53101 2.53113H56.5311V56.5312H2.53101V2.53113Z",
					fill: "white"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask1_117157_1874)",
				children: [/* @__PURE__ */ _jsxs("mask", {
					id: "mask2_117157_1874",
					style: { maskType: "alpha" },
					maskUnits: "userSpaceOnUse",
					x: 2,
					y: 2,
					width: 55,
					height: 55,
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M12.4306 48.2066L3.43105 41.4566C3.15042 41.2482 2.92275 40.9767 2.7664 40.6641C2.61006 40.3514 2.52943 40.0064 2.53103 39.6569V19.4066C2.52955 19.0572 2.61024 18.7122 2.76657 18.3997C2.92291 18.0871 3.15052 17.8156 3.43105 17.6072L12.4306 10.8569C12.1889 11.084 12.0062 11.3666 11.8985 11.6802C11.7908 11.9938 11.7612 12.329 11.8124 12.6567V46.4068C11.7613 46.7345 11.7909 47.0696 11.8986 47.3833C12.0063 47.6969 12.1889 47.9795 12.4306 48.2066Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M55.5296 11.9032C55.1587 11.6597 54.7244 11.5306 54.2807 11.532C53.9933 11.5297 53.7082 11.5841 53.4418 11.6921C53.1754 11.8001 52.9329 11.9596 52.7283 12.1615L52.5713 12.3191L34.6162 29.5318L24.6821 39.0604L15.4909 47.869L15.3333 48.0269C15.1288 48.229 14.8863 48.3887 14.6199 48.4968C14.3535 48.6049 14.0684 48.6594 13.7809 48.6571C13.2941 48.6562 12.8205 48.4982 12.4307 48.2066L3.43115 41.4566C3.88841 41.8001 4.45937 41.9564 5.0278 41.8936C5.59623 41.8309 6.11939 41.5539 6.49078 41.1191L16.4806 29.5208L24.6821 20.0034L39.0487 3.31897C39.2572 3.07174 39.5172 2.87316 39.8107 2.73718C40.1041 2.6012 40.4237 2.53113 40.7471 2.53187C41.1907 2.53039 41.625 2.65949 41.9957 2.90308L55.5296 11.9032Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M55.5296 47.1602L42.0297 56.1604C41.5704 56.4602 41.0184 56.5843 40.475 56.51C39.9315 56.4356 39.4332 56.1677 39.0713 55.7555L24.6821 39.0604L16.4806 29.5207L6.49078 17.9325C6.11611 17.502 5.59245 17.2291 5.02492 17.1687C4.4574 17.1083 3.88804 17.2649 3.43115 17.6069L12.4307 10.8569C12.8205 10.5654 13.2939 10.4074 13.7806 10.4064C14.0682 10.404 14.3534 10.4585 14.6199 10.5667C14.8864 10.6749 15.1288 10.8347 15.3333 11.0369L15.4909 11.1945L24.6821 20.0034L34.6162 29.5317L52.5713 46.7444L52.7283 46.902C52.9329 47.1039 53.1753 47.2635 53.4417 47.3715C53.7081 47.4795 53.9933 47.5339 54.2807 47.5315C54.7244 47.533 55.1588 47.4039 55.5296 47.1602Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M56.5311 13.7812V45.2821C56.5315 45.6534 56.4403 46.019 56.2656 46.3466C56.0909 46.6742 55.8381 46.9537 55.5295 47.1602L42.0296 56.1603C42.3381 55.9536 42.5909 55.674 42.7655 55.3462C42.9402 55.0185 43.0313 54.6527 43.0309 54.2813V4.78194C43.026 4.40779 42.929 4.0406 42.7484 3.71287C42.5678 3.38514 42.3093 3.10696 41.9956 2.90295L55.5295 11.9031C55.8372 12.1105 56.0894 12.3901 56.264 12.7175C56.4387 13.0449 56.5304 13.4101 56.5311 13.7812Z",
							fill: "white"
						})
					]
				}), /* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask2_117157_1874)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M12.4306 48.2066L3.43104 41.4566C3.15056 41.248 2.92299 40.9765 2.76666 40.6639C2.61034 40.3513 2.52962 40.0064 2.53103 39.6569V19.4066C2.52955 19.0572 2.61023 18.7122 2.76657 18.3997C2.9229 18.0871 3.15052 17.8156 3.43104 17.6072L12.4306 10.8569C12.1889 11.084 12.0062 11.3666 11.8985 11.6802C11.7908 11.9938 11.7612 12.329 11.8124 12.6567V46.4068C11.7613 46.7345 11.7909 47.0696 11.8986 47.3833C12.0063 47.6969 12.1889 47.9795 12.4306 48.2066Z",
							fill: "#5E438F"
						}),
						/* @__PURE__ */ _jsx("g", {
							filter: "url(#filter0_dd_117157_1874)",
							children: /* @__PURE__ */ _jsx("path", {
								d: "M55.5293 11.9032C55.1586 11.6597 54.7243 11.5306 54.2807 11.532C53.9933 11.5298 53.7082 11.5842 53.4418 11.6923C53.1755 11.8003 52.933 11.9597 52.7283 12.1615L52.5713 12.3191L43.008 21.4882L34.6162 29.5318L24.6818 39.0604L15.4909 47.869L15.333 48.0269C15.1285 48.229 14.886 48.3887 14.6196 48.4968C14.3532 48.6049 14.0681 48.6594 13.7806 48.6571C13.2939 48.6562 12.8204 48.4982 12.4307 48.2066L3.43115 41.4566C3.88839 41.8 4.45928 41.9562 5.02764 41.8935C5.596 41.8308 6.1191 41.5539 6.49047 41.1191L11.531 35.2694L16.4806 29.5208L24.6821 20.0034L39.0484 3.31897C39.257 3.07195 39.5172 2.87351 39.8105 2.73755C40.1039 2.60159 40.4235 2.5314 40.7468 2.53187C41.1905 2.53042 41.6248 2.65951 41.9957 2.90308L55.5293 11.9032Z",
								fill: "url(#paint0_linear_117157_1874)"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							filter: "url(#filter1_dd_117157_1874)",
							children: /* @__PURE__ */ _jsx("path", {
								d: "M55.5293 47.1602L42.0294 56.1607C41.5701 56.4606 41.0181 56.5848 40.4747 56.5103C39.9313 56.4359 39.433 56.1679 39.0713 55.7555L24.6821 39.0603L16.4806 29.5207L11.5313 23.7833L6.49047 17.9327C6.11582 17.5023 5.59224 17.2295 5.02481 17.1691C4.45738 17.1086 3.88808 17.265 3.43115 17.6068L12.4304 10.8572C12.8202 10.5656 13.2936 10.4077 13.7803 10.4067C14.0678 10.4043 14.353 10.4587 14.6194 10.5669C14.8859 10.6751 15.1283 10.8349 15.3327 11.0371L15.4906 11.1947L24.6815 20.0036L34.6162 29.5317L43.02 37.5871L52.5713 46.7443L52.7283 46.9022C53.1419 47.3094 53.7003 47.5357 54.2807 47.5314C54.7243 47.5329 55.1586 47.4038 55.5293 47.1602Z",
								fill: "url(#paint1_linear_117157_1874)"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							filter: "url(#filter2_dd_117157_1874)",
							children: /* @__PURE__ */ _jsx("path", {
								d: "M56.5311 13.7812V45.2818C56.5315 45.6531 56.4402 46.0187 56.2655 46.3464C56.0908 46.674 55.838 46.9535 55.5295 47.1602L42.0293 56.1603C42.3378 55.9536 42.5906 55.674 42.7653 55.3462C42.94 55.0185 43.0312 54.6527 43.0309 54.2813V4.78194C43.026 4.40779 42.929 4.0406 42.7484 3.71287C42.5678 3.38514 42.3093 3.10696 41.9956 2.90295L55.5295 11.9031C55.8371 12.1107 56.0891 12.3903 56.2637 12.7177C56.4383 13.0451 56.5301 13.4102 56.5311 13.7812Z",
								fill: "url(#paint2_linear_117157_1874)"
							})
						})
					]
				})]
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_117157_1874",
				x: 1.84595,
				y: 1.34296,
				width: 55.2686,
				height: 49.2957,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .0752819 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .0752819 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_117157_1874"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .396301 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .792602 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_117157_1874",
						result: "effect2_dropShadow_117157_1874"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_117157_1874",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_dd_117157_1874",
				x: 1.84595,
				y: 9.21771,
				width: 55.2686,
				height: 49.2952,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .0752819 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .0752819 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_117157_1874"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .396301 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .792602 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_117157_1874",
						result: "effect2_dropShadow_117157_1874"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_117157_1874",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_dd_117157_1874",
				x: 37.2394,
				y: -1.85327,
				width: 24.0481,
				height: 62.7698,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .0397831 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_117157_1874"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.37811 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_117157_1874",
						result: "effect2_dropShadow_117157_1874"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_117157_1874",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_117157_1874",
				x1: 46.4058,
				y1: 2.53157,
				x2: 6.30809,
				y2: 42.8891,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7252AA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7252AA"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_117157_1874",
				x1: 7.59339,
				y1: 12.375,
				x2: 45.2809,
				y2: 54.5623,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#AE7FE2" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#9A70D4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_117157_1874",
				x1: 49.1033,
				y1: 1.81687,
				x2: 49.1033,
				y2: 56.115,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D59DFF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C18EF1"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgVisualStudio);
export { ForwardRef as ReactComponent };
